import { restConfig } from "../authConfig";
import { useAppDispatch } from "../redux/hooks";
import { 
  fundingOverviewFetched, 
  postfundingTransactionCheckRequested, 
  postfundingTransactionCheckRequestFailure, 
  prefundingTransactionCheckRequested, 
  prefundingTransactionCheckRequestFailure, 
  loading, 
  fundingOverviewFetchFailure
} from "../redux/slices/fundingSlice";
import { CreditorFunding } from '../redux/types';
import useFetchClient from "./useFetchClient";

const useFundingActions = () => {
  const fetchClient = useFetchClient()
  const dispatch = useAppDispatch()

  const getFundingOverview = async (marketId: string) => {
    dispatch(loading())   

    return fetchClient.get(restConfig.routes.markets + `/${marketId}/funding`)
      .then(response => {
          dispatch(fundingOverviewFetched(response.data as CreditorFunding[]))
      })
      .catch(error => {
          console.log('getFundingOverview error:', error)
          dispatch(fundingOverviewFetchFailure(error))
      })
  }

  const requestPrefundingTransactionCheck = async (marketId: string) => {
    dispatch(loading())   

    return fetchClient.post(restConfig.routes.markets + `/${marketId}/funding/prefunding/check`)
      .then(response => {
          dispatch(prefundingTransactionCheckRequested())
      })
      .catch(error => {
          console.log('requestPrefundingTransactionCheck error:', error)
          dispatch(prefundingTransactionCheckRequestFailure(error))
      })
  }

  const requestPostfundingTransactionCheck = async (marketId: string) => {
    dispatch(loading())   

    return fetchClient.post(restConfig.routes.markets + `/${marketId}/funding/postfunding/check`)
      .then(response => {
          dispatch(postfundingTransactionCheckRequested())
      })
      .catch(error => {
          console.log('requestPostfundingTransactionCheck error:', error)
          dispatch(postfundingTransactionCheckRequestFailure(error))
      })
  }

  return {
    getFundingOverview,
    requestPrefundingTransactionCheck,
    requestPostfundingTransactionCheck
  }
}

export default useFundingActions
